import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import AddNewMessage from "../AddNewMessage";
import MessagingPopup from "../MessagingPopup";
import { getFormatedNumber } from "../../Services/appService";
import { getCurrentUser } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  getAppMessages, getAppTasks, getCandidateApps,
  loadAppMessages, loadAppRuningTasks, loadCandidateApps
} from "../../app/store/candidate";
import { getAlert } from "../../Services/appAlerts";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";

const MESSAGE_STYLES = {
  pageWrap: {
    padding: "12px 0 4px 0"
  },
  shell: {
    borderRadius: "24px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    boxShadow: "0 18px 38px rgba(15, 23, 42, 0.06)",
    overflow: "hidden"
  },
  hero: {
    padding: "24px 24px 18px 24px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
  },
  heroRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "16px",
    flexWrap: "wrap"
  },
  titleWrap: {
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  titleIcon: {
    width: "52px",
    height: "52px",
    borderRadius: "16px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "24px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
  },
  titleCopy: {
    minWidth: 0
  },
  eyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#4f46e5",
    marginBottom: "10px"
  },
  title: {
    fontSize: "24px",
    fontWeight: 800,
    lineHeight: 1.15,
    color: "#0f172a",
    margin: 0
  },
  subtitle: {
    fontSize: "14px",
    lineHeight: 1.6,
    color: "#475569",
    margin: "8px 0 0 0",
    maxWidth: "760px"
  },
  addButton: {
    border: "none",
    borderRadius: "999px",
    padding: "12px 18px",
    background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
    color: "#ffffff",
    fontSize: "13px",
    fontWeight: 700,
    boxShadow: "0 14px 28px rgba(79, 70, 229, 0.2)"
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginTop: "18px"
  },
  statCard: {
    borderRadius: "18px",
    padding: "14px 16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 10px 26px rgba(37, 99, 235, 0.06)"
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px"
  },
  statValue: {
    fontSize: "26px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1
  },
  statHint: {
    fontSize: "12px",
    lineHeight: 1.5,
    color: "#64748b",
    marginTop: "6px"
  },
  body: {
    padding: "20px 24px 24px 24px"
  },
  tableWrap: {
    borderRadius: "20px",
    overflow: "auto",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff"
  },
  table: {
    marginBottom: 0
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px"
  },
  cell: {
    verticalAlign: "middle",
    padding: "16px"
  },
  serialBadge: {
    minWidth: "34px",
    height: "34px",
    borderRadius: "999px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(79, 70, 229, 0.08)",
    color: "#4338ca",
    fontSize: "13px",
    fontWeight: 800
  },
  dateText: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#0f172a"
  },
  personName: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "4px"
  },
  metaLine: {
    fontSize: "12px",
    lineHeight: 1.55,
    color: "#64748b"
  },
  viewButton: {
    position: "relative",
    border: "none",
    borderRadius: "999px",
    padding: "10px 14px",
    background: "rgba(37, 99, 235, 0.08)",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 800
  },
  countBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "22px",
    height: "22px",
    borderRadius: "999px",
    marginLeft: "8px",
    fontSize: "11px",
    fontWeight: 800
  },
  unreadBadge: {
    background: "#ef4444",
    color: "#ffffff"
  },
  readBadge: {
    background: "#dcfce7",
    color: "#166534"
  },
  emptyState: {
    padding: "42px 20px",
    textAlign: "center",
    background: "linear-gradient(180deg, rgba(248,250,252,0.8) 0%, rgba(255,255,255,1) 100%)"
  },
  emptyIcon: {
    width: "64px",
    height: "64px",
    borderRadius: "20px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(79, 70, 229, 0.08)",
    color: "#4f46e5",
    fontSize: "28px",
    marginBottom: "14px"
  },
  emptyTitle: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px"
  },
  emptyText: {
    fontSize: "13px",
    lineHeight: 1.6,
    color: "#64748b",
    maxWidth: "460px",
    margin: "0 auto"
  }
};

export default function IndividualMsg() {

  const route = [{ url: "", name: "Task Management" }];
  const route1 = [{ name: "Contract Management", url: "" }];

  const usrType = localStorage.getItem("userType");

  const [appTasklist, setAppTasklist] = useState([]);
  const [appMessages, setAppMessage] = useState([]);
  const [wfId, setWfId] = useState(0);
  const [msgShowHide, setMsgShowHide] = useState(false);
  const [addMsgShowHide, setAddMsgShowHide] = useState(false);
  const [msgObj, setMsgObj] = useState("");
  const [wfTask, setWfTask] = useState(null);

  const candidateAppsSelector = useSelector(getCandidateApps);
  const appMessagesSelector = useSelector(getAppMessages);
  const appTasksSelector = useSelector(getAppTasks);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Message(s)"));
    dispatch(setCurrentRoute(usrType === "candidate" ? route : route1))
  }, [])

  useEffect(() => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (candidateAppsSelector.length === 0 && currentUser?.id > 0)
      dispatch(loadCandidateApps(usrId))
  }, []);

  useEffect(() => {
    if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
      const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
      if (mainWorkflow.length > 0) {
        const wf = mainWorkflow[0]
        setWfId(wf.oldWorkflowId);
        let usrId = currentUser.id;
        if (currentUser.linkUser)
          usrId = currentUser.linkUser;
        if (appMessagesSelector.length === 0)
          dispatch(loadAppMessages(wf.oldWorkflowId, usrId));
        if (appTasksSelector.length === 0)
          dispatch(loadAppRuningTasks(wf.oldWorkflowId, usrId));
      }
    }
  }, [candidateAppsSelector]);

  useEffect(() => {
    if (appMessagesSelector.length > 0) {
      setAppMessage(appMessagesSelector);
      // let msgItems = "";
      // appMessagesSelector.map((x, key) => {
      //   if (key > 0) msgItems += ",";
      //   msgItems += x.id;
      // })
      // handleUpdateComponent(msgItems, appMessagesSelector[0].ciid);
    }
  }, [appMessagesSelector]);



  useEffect(() => {
    if (appTasksSelector.length > 0) {
      const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0);
      if (filterTasks.length > 0) {
        setAppTasklist(filterTasks);
      }
    }
  }, [appTasksSelector])

  const handleAddNewMessagePopup = (app) => {
    if (app === "save") {
      setAddMsgShowHide(false);
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      dispatch(loadAppMessages(wfId, usrId));
    }
    else {
      const reviewApp = appTasklist.filter((x) => x.registrationType === "WP");
      if (reviewApp.length > 0) {
        const lastReviewer = reviewApp[reviewApp.length - 1];
        setWfTask([lastReviewer]);
      } else {
        getAlert("", "No reviewer found", "error");
      }
      setAddMsgShowHide(!addMsgShowHide);
    }
  };

  const handleMessagePopup = (obj) => {
    setMsgShowHide(!msgShowHide);
    setMsgObj(obj);
  };

  const handleSendMessage = () => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (wfId > 0)
      dispatch(loadAppMessages(wfId, usrId));
  }

  const totalMessages = appMessages.length;
  const unreadMessages = appMessages.reduce((count, item) => count + (item.unreadCount || 0), 0);
  const activeReviewers = new Set(
    appMessages
      .map((item) => (item.receiverId === parseInt(currentUser.id) ? item.sender : item.receiver))
      .filter(Boolean)
  ).size;

  return (
    <React.Fragment>
      <div className="col-md-12" style={MESSAGE_STYLES.pageWrap}>
        <div style={MESSAGE_STYLES.shell}>
          <div style={MESSAGE_STYLES.hero}>
            <div style={MESSAGE_STYLES.heroRow}>
              <div style={MESSAGE_STYLES.titleWrap}>
                <div style={MESSAGE_STYLES.titleIcon}>
                  <i className="fa fa-comments-o" aria-hidden="true"></i>
                </div>
                <div style={MESSAGE_STYLES.titleCopy}>
                  <h1 style={MESSAGE_STYLES.title}>Message Center</h1>
                  {/* <p style={MESSAGE_STYLES.subtitle}>
                    Track reviewer conversations, open unread threads quickly, and start a new message when you need clarification.
                  </p> */}
                </div>
              </div>
              <div>
                <button
                  style={MESSAGE_STYLES.addButton}
                  onClick={() => handleAddNewMessagePopup("")}
                >
                  <i className="fa fa-plus mr-2" aria-hidden="true"></i>
                  Add Message
                </button>
              </div>
            </div>
            <div style={MESSAGE_STYLES.statsRow}>
              <div style={MESSAGE_STYLES.statCard}>
                <div style={MESSAGE_STYLES.statLabel}>Total Threads</div>
                <div style={MESSAGE_STYLES.statValue}>{totalMessages}</div>
                <div style={MESSAGE_STYLES.statHint}>All message conversations available for this workflow.</div>
              </div>
              <div style={MESSAGE_STYLES.statCard}>
                <div style={MESSAGE_STYLES.statLabel}>Unread Replies</div>
                <div style={MESSAGE_STYLES.statValue}>{unreadMessages}</div>
                <div style={MESSAGE_STYLES.statHint}>Messages that still need your attention.</div>
              </div>
              <div style={MESSAGE_STYLES.statCard}>
                <div style={MESSAGE_STYLES.statLabel}>Contacts</div>
                <div style={MESSAGE_STYLES.statValue}>{activeReviewers}</div>
                <div style={MESSAGE_STYLES.statHint}>Distinct reviewers or recipients in your message list.</div>
              </div>
            </div>
          </div>
          <div style={MESSAGE_STYLES.body}>
            <div style={MESSAGE_STYLES.tableWrap}>
              <div className="table-responsive">
                <table className="table align-items-center table-hover mb-0" style={MESSAGE_STYLES.table}>
                  <thead>
                    <tr>
                      <th style={MESSAGE_STYLES.tableHeadCell}></th>
                      <th style={MESSAGE_STYLES.tableHeadCell}>Date & Time</th>
                      <th style={MESSAGE_STYLES.tableHeadCell}>Review Officer</th>
                      <th style={MESSAGE_STYLES.tableHeadCell}>Messages</th>
                    </tr>
                  </thead>
                  <tbody>
                    {appMessages.length > 0 ? appMessages.map((item, key) => (
                      <tr key={item.id || key}>
                        <td style={MESSAGE_STYLES.cell}>
                          <span style={MESSAGE_STYLES.serialBadge}>{key + 1}</span>
                        </td>
                        <td style={MESSAGE_STYLES.cell}>
                          <div style={MESSAGE_STYLES.dateText}>
                            <Moment format="MMM Do YYYY, h:mm a">
                              {item.addedDateTime}
                            </Moment>
                          </div>
                        </td>
                        <td style={MESSAGE_STYLES.cell}>
                          <div style={MESSAGE_STYLES.personName}>
                            {item.receiverId === parseInt(currentUser.id)
                              ? item.sender
                              : item.receiver}
                          </div>
                          {item.role && <div style={MESSAGE_STYLES.metaLine}>{item.role}</div>}
                          {item.email && <div style={MESSAGE_STYLES.metaLine}>{item.email}</div>}
                          {item.contact && <div style={MESSAGE_STYLES.metaLine}>{getFormatedNumber(item.contact)}</div>}
                        </td>
                        <td style={MESSAGE_STYLES.cell}>
                          <button
                            style={MESSAGE_STYLES.viewButton}
                            onClick={() => handleMessagePopup(item)}
                          >
                            View Conversation
                            {item.unreadCount > 0 &&
                              <span style={{ ...MESSAGE_STYLES.countBadge, ...MESSAGE_STYLES.unreadBadge }}>
                                {item.unreadCount}
                              </span>}
                            {item.readCount > 0 && item.unreadCount === 0 &&
                              <span style={{ ...MESSAGE_STYLES.countBadge, ...MESSAGE_STYLES.readBadge }}>
                                {item.readCount}
                              </span>}
                          </button>
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="4" style={{ ...MESSAGE_STYLES.cell, padding: 0 }}>
                          <div style={MESSAGE_STYLES.emptyState}>
                            <div style={MESSAGE_STYLES.emptyIcon}>
                              <i className="fa fa-envelope-open-o" aria-hidden="true"></i>
                            </div>
                            <div style={MESSAGE_STYLES.emptyTitle}>No messages yet</div>
                            <div style={MESSAGE_STYLES.emptyText}>
                              Your reviewer conversations will appear here. Use the Add Message button to start the first thread for this workflow.
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddNewMessage
        addMsgShowHide={addMsgShowHide}
        handleAddMsgModalShowHide={handleAddNewMessagePopup}
        runningApplication={wfTask}
      ></AddNewMessage>

      <MessagingPopup
        msgShowHide={msgShowHide}
        message={msgObj}
        handleMsgModalShowHide={handleMessagePopup}
        handleSendMessage={handleSendMessage}
      ></MessagingPopup>

    </React.Fragment>
  );
}
